<fieldset class="radio">
  @for (address of addressList; track address) {
    <div [formGroup]="form" class="row" (click)="toggleAddress(address)">
      <div class="flex pad-10">
        <input
          type="radio"
          formControlName="addressSelected"
          [value]="address"
          (change)="toggleAddress(address)"
        />
        <label class="checkbox-label" [attr.aria-label]="address"></label>
        <p class="pad-left-10">
          <span>{{ address?.addressLine1 }}</span
          ><br /><span>{{ address?.city }}, {{ address?.state }} {{ address?.zipCode }}</span>
        </p>
      </div>
    </div>
  }

  <div [formGroup]="form" class="row" (click)="toggleAddress('other')">
    <div class="flex pad-10">
      <input
        type="radio"
        formControlName="addressSelected"
        [value]="'other'"
        (change)="toggleAddress('other')"
      />
      <label class="checkbox-label" [attr.aria-label]="'somewhere else'"></label>
      <p class="pad-left-10">Somewhere else</p>
    </div>
  </div>
</fieldset>
